export default __webpack_public_path__ + "static/media/SendUSDC.bf899978.png";